import { render } from "./eb-trinket.vue?vue&type=template&id=299fdc7c"
import script from "./eb-trinket.vue?vue&type=script&lang=ts"
export * from "./eb-trinket.vue?vue&type=script&lang=ts"
script.render = render

export default script